'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var podOrderAddComponent = exports.podOrderAddComponent = {
    template: require('./pod-order-add.html'),
    controllerAs: 'vm',
    bindings: {},
    controller: ["common", "gettextCatalog", "$state", function podOrderAddController(common, gettextCatalog, $state) {
        'ngInject';

        var vm = this;

        vm.currentStep = 0;

        vm.receiver;
        vm.delivery;

        vm.initForm = initForm;
        vm.selectReceiver = selectReceiver;
        vm.editReceiver = editReceiver;
        vm.submitStep2 = submitStep2;
        vm.editStep2 = editStep2;
        vm.submitStep3 = submitStep3;
        vm.cancel = cancel;

        vm.$onInit = init;

        function init() {
            common.setTitle(gettextCatalog.getString('Add package'));

            initForm();
        }

        function initForm() {
            vm.currentStep = 1;
            vm.receiver = null;
            vm.delivery = null;
        }

        function selectReceiver($event) {
            vm.currentStep = 2;
            vm.receiver = $event;
        }

        function submitStep2($event) {
            vm.currentStep = 3;
            vm.delivery = $event;
        }

        function submitStep3($event) {
            vm.currentStep = 4;

            $state.go('add-package-confirmation');
        }

        function editReceiver() {
            vm.currentStep = 1;
        }

        function editStep2() {
            vm.currentStep = 2;
        }

        function cancel() {
            $state.go('my-packages');
        }
    }]
};


//////////////////
// WEBPACK FOOTER
// ./features/account/my-packages/pod-order-add.js
// module id = 863
// module chunks = 0